import React from 'react';
import { Box, FormControl, MenuItem, Select } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Styled ExpandMoreIcon
const CustomExpandMoreIcon = styled(ExpandMoreIcon)({
  fontSize: '1.9rem',
  top: '13px',
  right: '0px',
  width: '28px',
  height: '28px',
  marginRight: '8px',
  color: '#1d6460',
});

// Styled FormControl (optional, you can style Box or Select similarly)
const StyledFormControl = styled(FormControl)({
  alignSelf: 'none',
  width: 'auto',
  marginLeft: '0px',
});

const StyledBox = styled(Box)({
  width: 'auto',
});

export default function CustomDropDown({
  dropDownStyle,
  boxStyle,
  handleChange,
  selectData,
  menuData,
}) {
  const MenuProps = {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    getContentAnchorEl: null,
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    PaperProps: {
      style: {
        maxHeight: '316px',
        zIndex: '0',
        border: '1px solid #D0D0D3',
        boxShadow:
          '0px 1px 2px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.5)',
        borderRadius: '2px',
      },
    },
  };
  return (
    <StyledBox sx={boxStyle}>
      <StyledFormControl variant="outlined" sx={dropDownStyle}>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={selectData.selectedValue}
          name={selectData.attributeCode}
          onChange={handleChange}
          IconComponent={CustomExpandMoreIcon}
          MenuProps={MenuProps}
        >
          {menuData.map((ele) => (
            <MenuItem key={ele.parameterCode} value={ele.parameterCode}>
              {ele.parameterDesc}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    </StyledBox>
  );
}

CustomDropDown.defaultProps = {
  dropDownStyle: {
    alignSelf: 'none',
    width: 'auto',
    marginLeft: '0px',
  },
  boxStyle: {
    width: 'auto',
  },
};
CustomDropDown.propTypes = {
  selectData: PropTypes.shape({
    selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    attributeCode: PropTypes.string,
  }).isRequired,
  menuData: PropTypes.arrayOf(
    PropTypes.shape({
      parameterCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      parameterDesc: PropTypes.string,
    })
  ).isRequired,
  handleChange: PropTypes.func.isRequired,
  dropDownStyle: PropTypes.string,
  boxStyle: PropTypes.string,
};
